/* @flow */
import React from 'react';
import IconButton from '../IconButton/IconButton';
import {Content as PercentBookedSearchBannerContent} from './percentBookedContents';
import {Content as UrgentMessageSearchBannerContent} from './urgentMessageContents';
import {Content as DestinationSearchBannerContent} from './destinationMessage';

import type {Element as ReactElement, Node} from 'react';

import './SearchBanner.less';

type ChildrenElementType =
    | typeof PercentBookedSearchBannerContent
    | typeof UrgentMessageSearchBannerContent
    | typeof DestinationSearchBannerContent;

type SearchBannerProps = {
    children: ReactElement<ChildrenElementType>,
    icon?: Node,
    onDismiss: Function
};

// TODO replace with AlertInfo from @homeaway/react-alerts
// See https://jira.homeawaycorp.com/browse/SERP-1058
export default function SearchBanner({
    children,
    icon,
    onDismiss
}: SearchBannerProps) {
    return (
        <div className="SearchBanner" data-wdio="SearchBanner">
            {icon && <div className="SearchBanner__icon">{icon}</div>}
            <div className="SearchBanner__content">{children}</div>
            <div className="SearchBanner__close">
                <IconButton icon="close" onClick={onDismiss} />
            </div>
        </div>
    );
}
